export class Stream {
    id: number;
    title: string;
    country: string;
    genre: string;
    url: string;
    logo: string;
    type: string;

    public static fromResponseData(data: object): Stream {
        const stream = new Stream();

        stream.id = data['id'];
        stream.title = data['title'];
        stream.country = data['country'];
        stream.genre = data['genre'];
        stream.url = data['url'];        
        stream.type = data['type'] !== undefined ? data['type'] : 'radio';

        if (stream.type === 'podcast') {
            stream.logo = data['logo'];
        } else {
            stream.logo = data['logo'] !== null ? 'img/stations/' + data['logo'] : 'img/microphone_icon.png';
        }

        return stream;
    }

    public static fromPodcastResponseData(data: object): Stream {
        const stream = new Stream();

        stream.id = data['id'];
        stream.title = data['title_original'] !== undefined ? data['title_original'] : data['title'];
        //stream.country = data['country'];
        //stream.genre = data['genre'];
        stream.url = data['rss'];
        stream.logo = data['image'];
        stream.type = 'podcast';

        return stream;

        /*
        const podcast = new Podcast();

        podcast.id = data['id'];
        podcast.title = data['title'];
        podcast.description = data['description'];
        podcast.publisher = data['publisher'];
        podcast.image = data['image'];
        podcast.thumbnail = data['thumbnail'];

        podcast.totalEpisodes = data['total_episodes'];

        podcast.rssUrl = data['rss'];

        return podcast;
         */
    }
}